/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingQualityEventTypeData
 */
export interface TrackingQualityEventTypeData {
    /**
     * 
     * @type {string}
     * @memberof TrackingQualityEventTypeData
     */
    event?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityEventTypeData
     */
    amount?: number;
}

/**
 * Check if a given object implements the TrackingQualityEventTypeData interface.
 */
export function instanceOfTrackingQualityEventTypeData(value: object): value is TrackingQualityEventTypeData {
    return true;
}

export function TrackingQualityEventTypeDataFromJSON(json: any): TrackingQualityEventTypeData {
    return TrackingQualityEventTypeDataFromJSONTyped(json, false);
}

export function TrackingQualityEventTypeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingQualityEventTypeData {
    if (json == null) {
        return json;
    }
    return {
        
        'event': json['event'] == null ? undefined : json['event'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function TrackingQualityEventTypeDataToJSON(json: any): TrackingQualityEventTypeData {
    return TrackingQualityEventTypeDataToJSONTyped(json, false);
}

export function TrackingQualityEventTypeDataToJSONTyped(value?: TrackingQualityEventTypeData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': value['event'],
        'amount': value['amount'],
    };
}

